// Styles for Stepper go here.
import styled from 'styled-components';
import { baseVariables, toRem } from '../../styles';

export const StyledStepper = styled.div`
  button:focus-visible {
    outline: ${toRem(1)} solid ${baseVariables.color.black};
  }

  .disable-hover {
    cursor: not-allowed;
  }

  .btn-disable {
    pointer-events: none;
  }

  /* Variation: bordered */
  .m-stepper-wrapper-square .m-stepper-square {
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    min-width: ${toRem(120)};
    height: ${toRem(32)};

    .decrement-btn.active-decrement {
      border: ${toRem(1)} solid ${baseVariables.color.neutral40};
    }
    .decrement-btn.disable-decrement {
      border: ${toRem(1)} solid ${baseVariables.color.neutral30};
      cursor: auto;
    }
    .increment-btn.active-increment {
      border: ${toRem(1)} solid ${baseVariables.color.neutral40};
    }
    .increment-btn.disable-increment {
      border: ${toRem(1)} solid ${baseVariables.color.neutral30};
      cursor: auto;
    }
  }

  .m-stepper-wrapper-square .m-stepper-square .decrement-btn {
    border: ${toRem(1)} solid ${baseVariables.color.neutral30};
    border-top-left-radius: ${toRem(4)};
    border-bottom-left-radius: ${toRem(4)};
    width: ${toRem(32)};
    height: ${toRem(32)};
    cursor: pointer;
    button {
      background: transparent;
      color: ${baseVariables.color.neutral00};
    }
  }
  .m-stepper-wrapper-square .m-stepper-square .counter {
    border-width: ${toRem(1)} 0 ${toRem(1)} 0;
    border-style: solid;
    border-color: ${baseVariables.color.neutral30};
    font-weight: ${baseVariables.font.fontWeightMedium};
    font-size: ${toRem(14)};
    line-height: 150%;
    letter-spacing: 0;
    text-align: center;
    width: ${toRem(56)};
    height: ${toRem(32)};
    padding: 0 ${toRem(8)};
    white-space: nowrap;
  }
  .m-stepper-wrapper-square .m-stepper-square .increment-btn {
    border: ${toRem(1)} solid ${baseVariables.color.neutral40};
    border-top-right-radius: ${toRem(4)};
    border-bottom-right-radius: ${toRem(4)};
    width: ${toRem(32)};
    height: ${toRem(32)};
    cursor: pointer;
    button {
      background: transparent;
      color: ${baseVariables.color.neutral00};
    }
  }
`;
